import { FIELD_TYPES } from '@iconik-io/shared-lib/src/constants/search';
import type { UploaderState } from '@iconik-io/uploader/src/state';

import type { Column } from '../../ui/table/types';
import { FileStatus } from './file_status';
import FileTitle from './file_title';

const columnsCompact: Column<UploaderState>[] = [
  {
    name: 'fileInfo.targetPath',
    style: { width: 'auto', overflow: 'hidden' },
    type: FIELD_TYPES.CUSTOM_COMPONENT,
    component: ({ item }) => <FileTitle item={item} />,
  },
  {
    name: 'status',
    type: FIELD_TYPES.CUSTOM_COMPONENT,
    style: { width: 'auto' },
    component: ({ item }) => <FileStatus item={item} />,
  },
];

export default columnsCompact;
